import Chart from "chart.js/auto";
import axios from 'axios';

const chart = document.querySelector('#main-chart');

const COLORS = [
  '#4dc9f6',
  '#f67019',
  '#537bc4',
  '#f53794',
  '#ffcc00',
  '#166a8f',
  '#00a950',
  '#58595b',
  '#8549ba'
];

function color(index) {
  return COLORS[index % COLORS.length];
}

function initChart(chartEl)
{
  const data = JSON.parse(chartEl.dataset.chartData);
  const labels = JSON.parse(chartEl.dataset.chartLabels);
  const datasets = [];
  let col = 1;
  for (const [key, value] of Object.entries(data)) {
    datasets.push({
      data : value,
      label : key,
      fill : false,
      borderColor: color(col)
    })
    col++;
  }
  new Chart(chartEl, {
    type : 'line',
    data : {
      labels : labels,
      datasets : datasets
    },
    options: {
      aspectRatio: 3,
      interaction: {
        intersect: false,
        mode: 'index',
      },
    }
  });
}

document.querySelectorAll('[data-init-chart]').forEach((chartEl) => {
  initChart(chartEl);
});


function initChartItem(chartEl) {
  if (chartEl.dataset.inited) {
    return false;
  }
  chartEl.dataset.inited = 'true';
  const data = JSON.parse(chartEl.dataset.chartData);
  const labels = JSON.parse(chartEl.dataset.chartLabels);
  const datasets = [];
  let col = 1;
  for (const [key, value] of Object.entries(data)) {
    datasets.push({
      data : value,
      label : key,
      fill : false,
      borderColor: color(col)
    })
    col++;
  }
  new Chart(chartEl, {
    type : 'line',
    data : {
      labels : labels,
      datasets : datasets
    },
    options: {
      interaction: {
        intersect: false,
        mode: 'index',
      },
    }
  });
}

function toggleChartLink(linkEl) {
  const chartWrapperEls = linkEl.parentElement.querySelectorAll('[data-chart-wrapper]');

  chartWrapperEls.forEach((chartWrapperEl) => {
    const chartEl = chartWrapperEl.querySelector('[data-chart-item]');

    chartWrapperEl.classList.toggle('_opened');
    if (chartWrapperEl.classList.contains('_opened')) {
      initChartItem(chartEl);
    }
  })
}

document.querySelectorAll('[data-popular-offer-chart-link]').forEach((linkEl) => {
  linkEl.addEventListener('click', () => {
    toggleChartLink(linkEl);
  })
})
